<template>
  <div>
    <h2>{{ title }}</h2>
    <div>
      <p>
        I am currently a Software Engineer at
        <a href="https://www.google.com/" target="_blank">Google</a>.
      </p>
    </div>
    <div id="future">
    </div>
    <div id="previous">
      <p>
        Previously I have worked at
        <a href="https://www.flexport.com/" target="_blank">Flexport</a>,
        <a href="https://www.opendoor.com/" target="_blank">Opendoor</a>,
        <a href="https://www.google.com/" target="_blank">Google</a>,
        <a href="https://www.datadoghq.com/" target="_blank">Datadog</a>, and
        <a href="https://www.sculptor.com/" target="_blank">Sculptor Capital Management</a> as a Software Engineer Intern.
      </p>
    </div>
    <div id="goal">
      <p>My goals are to learn as much as possible from my experiences and interactions with others, and leave a positive impact on the company through my work.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      title: "Hello! I am Dian."
    };
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Catamaran|Martel+Sans");

h2 {
  font-size: 2em;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: left;
  font-family: "Catamaran", sans-serif;
}
div {
  margin-bottom: 20px;
}
p {
  font-family: serif;
  font-weight: 300;
  text-align: left;
  font-family: "Martel Sans", sans-serif;
}
#future p {
  margin-bottom: 0;
}
a {
  color: #f05e25;
  text-decoration: none;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
a:hover {
  color: #c04729;
  background: rgba(0, 0, 0, 0.05);
  text-decoration: none;
  border-radius: 3px;
  margin-bottom: 2px;
}
</style>
